import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import BootstrapVue from 'bootstrap-vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './scss/dh-north.scss'
import VueScrollTo from 'vue-scrollto'
import vueVimeoPlayer from 'vue-vimeo-player'

Vue.use(VueAxios, axios)
Vue.use(BootstrapVue)
Vue.use(Viewer)
Vue.use(VueScrollTo)
Vue.use(vueVimeoPlayer)

Vue.config.productionTip = false

Vue.mixin({
  methods: {
    getPath (path) {
      let output = path + '/' + this.lang
      output.replace('//', '/')
      return output
    },
    normalize (html) {
      // let parser = new DOMParser()
      let content = html
      let newContent = content
      if (content) {
        let critRel = /a href="\/.+?"/g
        let critAbs = /a href="https:\/\/dh-north\.org\/.+?"/g
        let linksRel = content.match(critRel)
        let linksAbs = content.match(critAbs)
        let newLinks = []
        if (linksRel && Array.isArray(linksRel)) {
          linksRel.forEach(l => {
            let newLink = l.slice(0, -1) + '/' + this.$store.state.lang + '"'
            newLinks.push(newLink)
          })
        }
        if (newLinks && linksRel) {
          newLinks.forEach((nl, index) => {
            newContent = newContent.replace(linksRel[index], nl)
          })
        }
        if (linksAbs && Array.isArray(linksAbs)) {
          linksAbs.forEach(l => {
            let newLink = l.slice(0, -1) + '/' + this.$store.state.lang + '"'
            newLinks.push(newLink)
          })
        }
        if (newLinks && linksAbs) {
          newLinks.forEach((nl, index) => {
            newContent = newContent.replace(linksAbs[index], nl)
          })
        }
      }
      return newContent
    }
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
